'use client'
import { useEffect } from 'react'

import { CONFIG_GLADLY_HELP_CENTER_CDN, GLADLY_API_URL, GLADLY_ORG_ID, GLADLY_SDK_URL } from '@src/config/env'
// create a custom hook

export const useGladlyHelpCenter = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const CONFIG_ID = 'gladly-chat-widget-install'
      const SCRIPT_ID = 'gladly-help-center-sdk'
      const configScript = document.createElement('script')
      configScript.id = CONFIG_ID
      configScript.innerHTML = ` window.gladlyHCConfig = { api: '${GLADLY_API_URL}', orgId: '${GLADLY_ORG_ID}', brandId: 'quince.com-en-us', cdn: '${CONFIG_GLADLY_HELP_CENTER_CDN}', selector: '#gladly-help-center', autoShowButton: false };` // # nosemgrep

      const sdkScript = document.createElement('script')
      sdkScript.id = SCRIPT_ID
      sdkScript.innerHTML = `function l() { var t = document, e = t.createElement('script'); (e.type = 'text/javascript'), (e.async = !0), (e.src = '${GLADLY_SDK_URL}'); var a = t.getElementsByTagName('script')[0]; a.parentNode.insertBefore(e, a); } var w = window; w.attachEvent ? w.attachEvent('onload', l) : w.addEventListener('DOMContentLoaded', l, !1); l(); ` // # nosemgrep
      document.head.appendChild(configScript)
      document.head.appendChild(sdkScript)
    }

    return () => {
      window.gladlyHCLoaded = false
    }
  }, [])
}
